import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SimpleModal } from 'components/Shared';
import { ConsultWithUs } from 'components/ConsultWithUs/ConsultWithUs';

function ViewConsultWithUs() {
  const dispatch = useDispatch();
  const {
    viewConsultWithUs: { show },
  } = useSelector(state => state.modal);

  const renderHeading = () => {
    return (
      <div className="tw-w-full  tw-pl-8 pt-4">
        <h5>An interior designer will call you. </h5>
        <h6 className="text-2-color">We need your information to set up the call.</h6>
      </div>
    );
  };
  return (
    <SimpleModal
      heading={renderHeading()}
      open={show}
      onClose={() => dispatch({ type: 'HIDE_CONSULT_WITH_US' })}
      fullWidth
      maxWidth="md"
    >
      <ConsultWithUs />
    </SimpleModal>
  );
}

export { ViewConsultWithUs };
